import React, {Component} from 'react';
import DetailedSearch from "./DetailedSearch/DetailedSearch";
import Table from "./Table/Table";
import TextOverFlowTooltip from "./TextOverFlowTooltip";
import moment from "moment/moment";
import {request} from "../helper/APIUtils";
import {getYearsList, showAxiosError} from "../helper/helper";
import NavBarKS from "./NavBarKS";
import YearPicker from "../accounting/einvoice/YearPicker";
import {checkMonthBased, showDateFilter} from "../helper/permission";
import {EntegratorConf} from "../constants";
import SoapService from "../common/SoapService";
import Alert from "react-s-alert";
import SoapDownloader from "../accounting/edefter/component/SoapDownloader";
import SoapDownloader2 from "../accounting/edefter/component/SoapDownloader2";

class MuhasebeciDefterBilgi extends Component {
    constructor(props) {
        super(props);
        let yearsList = getYearsList();

        let soapService = new SoapService(this.props.soapUrl, (error) => {
            Alert.error('Hata: ' + error.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 4000,
                html: false
            });
        });


        this.state = {
            content: [],
            total: 0,
            loading: false,
            page: 0,
            size: 10,
            searchQuery: undefined,
            years: yearsList,
            year: yearsList[0],
            month: new Date().getMonth(),
            soapService: soapService,
            fiscalYearList: [],
            periodAllBatchesList: [],
            periodList: [],
            summary: [],
            searching: false,

        };
        this.fetchData = this.fetchData.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.setYear = this.setYear.bind(this);
        this.setMonth = this.setMonth.bind(this);
        this.periodAllBatchesSelected = this.periodAllBatchesSelected.bind(this);
        this.fiscalYearSelected = this.fiscalYearSelected.bind(this);
        this.init = this.init.bind(this);
        this.downloadPeriodAllBatchesClicked = this.downloadPeriodAllBatchesClicked.bind(this);
    }

    fetchData(accessor, direction, page, size) {
        let year = !this.state.year.value ? 2019 : this.state.year.value;
        let month = showDateFilter(EntegratorConf.identifier) ? this.state.month : 12;

        const sortStr = accessor ? `&sort=${accessor},${direction}` : '';
        const searchQuery = this.state.searchQuery ? `&${this.state.searchQuery}` : '';
        const params = {
            url: `/muhasebeDefter/getMuhasebeDefter?year=${year}&month=${month}&page=${page}&size=${size}${sortStr}${searchQuery}`,
            method: "post",
            data: {
                profileId: this.props.profileId
            }
        };

        this.setState({loading: true});

        request(params)
            .then(response => {
                this.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    content: response.data.content,
                    loading: false,
                    searching:false
                });
                this.props.reload(false);
            })
            .catch(error => {
                this.setState({loading: false});
                this.props.reload(false);
                showAxiosError(error);
            });
    }


    periodAllBatchesSelected() {
        this.setState({
            periodLoading: !!this.state.selectedPeriodAllBatchesId,
            periodList: []
        });

        if (this.state.selectedPeriodAllBatchesId) {
            this.state.soapService.invoke("readPeriodsFull", {
                periodAllBatchesId: this.state.selectedPeriodAllBatchesId
            }, (error, result) => {

                this.setState({periodLoading: false});

                if (error)
                    return;

                this.setState({
                    periodList: result.return || [],
                    loading: false,
                });
            });
        }
    }
    downloadPeriodAllBatchesClicked(e) {
        let periodAllBatchesId = e.periodAllBatchesId;
        let promise = this.state.soapService
            .promise('readPeriodAllBatchesFullContent', {periodAllBatchesId: periodAllBatchesId})
            .then(response => {
                return response.return;
            });
        this.setState({
            soapDownloader2: promise,
            soapDownloader2Key: Math.random(),
            soapDownloader2Name: "Aylık Hesap Dönemi"
        });
    }

    fiscalYearSelected() {
        this.setState({
            periodAllBatchesLoading: !!this.state.selectedFiscalYearId,
            periodAllBatchesList: [],
            periodList: [],
            summary: [],
            summaryLoading: !!this.state.selectedFiscalYearId
        });

        if (this.state.selectedFiscalYearId) {
            this.state.soapService.invoke("readPeriodAllBatches", {
                fiscalYearId: this.state.selectedFiscalYearId
            }, (error, result) => {

                this.setState({periodAllBatchesLoading: false});

                if (error)
                    return;

                result.return && result.return.reverse();

                this.setState({
                    periodAllBatchesList: result.return || [],
                    loading: false,
                    selectedPeriodAllBatchesId: result.return && result.return[0].periodAllBatchesId
                }, () => this.periodAllBatchesSelected());
            });
            this.state.soapService.invoke("readFiscalYearSummary", {
                fiscalYearId: this.state.selectedFiscalYearId
            }, (error, result) => {

                this.setState({summaryLoading: false});

                if (error)
                    return;

                this.setState({summary: result.return || []});
            });
        }
    }
    componentDidMount() {
        this.init();
    }

    init() {
        this.setState({
            fiscalYearLoading: true
        });

        this.state.soapService.invoke("readFiscalYears", {}, (error, result) => {

            this.setState({
                fiscalYearLoading: false
            });

            if (error)
                return;

            result.return && result.return.reverse();

            this.setState({
                fiscalYearList: result.return || [],
                selectedFiscalYearId: result.return && result.return[0].fiscalYearId
            }, () => this.fiscalYearSelected());
        });
    }

    handleSearch(searchQuery) {
        this.setState({searchQuery, searching: true}, () =>
            this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size)
        );
    }

    setYear(year) {
        let month;
        let date = new Date();
        if (year.value === date.getFullYear()) {
            month = new Date().getMonth();
        } else {
            month = 0;
        }
        this.setState({
            year,
            month,
            searchQuery: undefined,
            selectedPeriodAllBatchesId: null
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size));
    }

    setMonth(month) {
        this.setState({
            month,
            searchQuery: undefined,
            selectedPeriodAllBatchesId: null
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size));
    }


    render() {
        const columns = [
            {
                Header: "VKN/TCKN",
                accessor: "vknTckn",
                Cell: row => (<div><TextOverFlowTooltip text={row.vknTckn} maxLength={23}/></div>)
            },
            {
                Header: "Müşteri Adı",
                accessor: "customerName",
                Cell: row => (<div><TextOverFlowTooltip text={row.customerName} maxLength={23}/></div>)
            },
            {
                Header: "Defter Dönemi",
                accessor: "startDate",
                Cell: row => {
                    const {startDate, secondaryYear, secondaryMonth, transferYear, transferMonth} = row;
                    let displayDate = '';

                    if (moment(startDate).isValid()) {
                        displayDate = moment(startDate).format("YYYY-MM");
                    } else if (secondaryYear && secondaryMonth) {
                        displayDate = `${secondaryYear}-${String(secondaryMonth).padStart(2, '0')}`;
                    } else if (transferYear && transferMonth) {
                        displayDate = `${transferYear}-${String(transferMonth).padStart(2, '0')}`;
                    }

                    return <div>{displayDate}</div>;
                }
            },
            {
                Header: "Gönderim Zamanı",
                accessor: "sendAt",
                Cell: row => {
                    const {serviceIds, sendAt} = row;
                    const serviceIdList = serviceIds
                        .replace("{", "")
                        .replace("}", "")
                        .split(",")
                        .map(id => parseInt(id.trim(), 10));

                    if (!serviceIdList.includes(3)) {
                        return <div>Hizmet Yok</div>;
                    }
                    return (
                        <div>
                            {moment(sendAt).isValid() ? moment(sendAt).format("DD-MM-YYYY HH:mm") : ''}
                        </div>
                    );
                }
            },
            {
                Header: "Saklama Zamanı",
                accessor: "receivedDate",
                Cell: row => {
                    const {serviceIds, receivedDate} = row;
                    const serviceIdList = serviceIds
                        .replace("{", "")
                        .replace("}", "")
                        .split(",")
                        .map(id => parseInt(id.trim(), 10));

                    if (!serviceIdList.includes(5)) {
                        return <div>Hizmet Yok</div>;
                    }
                    return (
                        <div>
                            {moment(receivedDate).isValid() ? moment(receivedDate).format("DD-MM-YYYY HH:mm") : ''}
                        </div>
                    );
                }
            },
            {
                Header: "İkinci Kopya Gönderim Zamanı",
                accessor: "resultAt",
                Cell: row => {
                    const {serviceIds, resultAt} = row;
                    const serviceIdList = serviceIds
                        .replace("{", "")
                        .replace("}", "")
                        .split(",")
                        .map(id => parseInt(id.trim(), 10));

                    if (!serviceIdList.includes(121)) {
                        return <div>Hizmet Yok</div>;
                    }
                    return (
                        <div>
                            {moment(resultAt).isValid() ? moment(resultAt).format("DD-MM-YYYY") : ''}
                        </div>
                    );
                }
            },
            {
                Header: "Defter İndir",
                accessor: "spent",
                sortable: false,
                Cell: row => (
                    row.periodAllBatchesId !== null ? (
                        <div>
                            {row.periodAllBatchesId &&(
                                <a href="#" onClick={() => this.downloadPeriodAllBatchesClicked(row)}>
                                    <img
                                        className="simple-text logo-mini"
                                        src={process.env.REACT_APP_CONTEXT_NAME + "/image/down-icon.png"}
                                    />
                                </a>
                            )}
                        </div>
                    ) : null
                )
            }
        ];
        const fields = [
            {
                label: "Müşteri Adı",
                accessor: "customerName",
                type: "text",
                operator: "="
            },
            {
                label: "VKN/TCKN",
                accessor: "vknTckn",
                type: "numericText",
                operator: "="
            }
        ];

        return (
                <div className="row baseBackground">
                    <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}
                              name="muhasebeDefter"/>
                    <div className="col-sm-12 satirBasi">
                        <div className="card-header">
                            <h4 className="card-title">Müşteri Defter Bilgi</h4>
                        </div>
                        <div className="card-body">
                            <DetailedSearch
                                fields={fields}
                                loading={this.state.searching}
                                onSearch={this.handleSearch}
                            />
                        </div>
                        <div className="col-sm-12">
                            <YearPicker years={this.state.years}
                                        checkMonthBased={checkMonthBased(EntegratorConf.identifier, this.state.year.value)}
                                        selectedYear={this.state.year.value}
                                        selectedMonth={this.state.month}
                                        selectedYearLabel={this.state.year.label}
                                        onSetYear={this.setYear}
                                        onSetMonth={this.setMonth}
                                        loading={this.state.loading}
                                        type={showDateFilter(EntegratorConf.identifier) ? "fulldate" : ""}
                                        hideReceivedDate={true}
                            />
                        </div>
                        <div className="card-body row">
                            <Table
                                columns={columns}
                                loading={this.state.loading}
                                loadingText="Kayıtlar getiriliyor..."
                                content={this.state.content}
                                total={this.state.total}
                                page={this.state.page}
                                size={this.state.size}
                                options={["5", "10", "20", "50", "100"]}
                                fetchData={this.fetchData}
                            />
                        </div>
                        <SoapDownloader soapService={this.state.soapService}
                                        value={this.state.edefterDownloaderSelected}
                                        isOpen={this.state.edefterDownloaderSelected}
                                        toggle={() => this.setState({edefterDownloaderSelected: null})}/>
                        <SoapDownloader2 name={this.state.soapDownloader2Name}
                                         valueKey={this.state.soapDownloader2Key}
                                         value={this.state.soapDownloader2}
                                         toggle={() => this.setState({soapDownloader2: null})}/>
                    </div>
                </div>
        );
    }
}

export default MuhasebeciDefterBilgi;
